import CarouselBanner_1_1 from './CarouselBanner_1_1';
import CarouselBanner_1_1_full from './CarouselBanner_1_1_full';
import CarouselBanner_1_1_small from './CarouselBanner_1_1_small';
import CarouselBanner_1_4_2_full from './CarouselBanner_1_4_2_full';
import CarouselBanner_1_5_1 from './CarouselBanner_1_5_1';
import CarouselBanner_1_5_1_full from './CarouselBanner_1_5_1_full';
import CarouselBanner_1_5_2 from './CarouselBanner_1_5_2';
import CarouselBanner_1_5_2_bigger from './CarouselBanner_1_5_2_bigger';
import CarouselBanner_1_6_1 from './CarouselBanner_1_6_1';
import CarouselBanner_1_6_2 from './CarouselBanner_1_6_2';
import CarouselBanner_2_5_1 from './CarouselBanner_2_5_1';
import CarouselBannerBase from './CarouselBannerBase';

export const CarouselBanner = {
  CarouselBanner_1_1: CarouselBanner_1_1,
  CarouselBanner_1_1_full: CarouselBanner_1_1_full,
  CarouselBanner_1_4_2_full: CarouselBanner_1_4_2_full,
  CarouselBanner_1_5_1: CarouselBanner_1_5_1,
  CarouselBanner_1_5_1_full: CarouselBanner_1_5_1_full,
  CarouselBanner_1_5_2: CarouselBanner_1_5_2,
  CarouselBanner_1_5_2_bigger: CarouselBanner_1_5_2_bigger,
  CarouselBanner_1_6_1: CarouselBanner_1_6_1,
  CarouselBanner_1_6_2: CarouselBanner_1_6_2,
  CarouselBanner_2_5_1: CarouselBanner_2_5_1,
  CarouselBanner_dynamic: ({ item }) => {
    return <CarouselBannerBase item={item} activeBigger={false} isCentered={false}></CarouselBannerBase>;
  },
  CarouselBanner_1_1_small: CarouselBanner_1_1_small,
};
